

export class EnrollmentLookup { 

    static GetSex(id: number): string {

        switch (id) {
            case (0): return "Female";
            case (1): return "Male";
            case (2): return "Intersex";
            case (3): return "Prefer Not To Answer";
            case (4): return "Unknown";
            default: return "Unknown";
        }
    }

    static GetRace(id: number): string {

        switch (id) {
            case (0): return "Multi";
            case (1): return "AIAN";
            case (2): return "Asian";
            case (3): return "Black";
            case (4): return "MENA";
            case (5): return "NHPI";
            case (6): return "White";
            case (7): return "Unknown";
            default: return "Unknown";
        }
    }

    static GetAgeGroup(id: number): string {

        switch (id) {
            case (0): return "18-45";
            case (1): return "46-65";
            case (2): return "+65";
            case (3): return "Unknown";
            default: return "Unknown";
        }
    }

    static GetYesNo(id: number): string {

        switch (id) {
            case (0): return "No";
            case (1): return "Yes";
            case (2): return "Unknown";
        }
    }
}